import produce from 'immer';

// TYPES
import { Types, CadastrarSufixo } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: CadastrarSufixo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarSufixo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_SUFIXO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_SUFIXO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_SUFIXO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_SUFIXO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
